// extracted by mini-css-extract-plugin
export var columnList = "_cy-0";